export default "__VITE_ASSET__c2f37d1e__"